<template>
    <div>
        <b-button @click="showModal" size="sm" class="mr-2">Details</b-button>
        <b-modal id="payment-plan-details" v-model="show" size="lg" title="Payment Plan Details" no-fade hide-footer>
            <b-list-group>
                <b-list-group-item><b>Customer A#</b>: {{ ANumber }}</b-list-group-item>
                <b-list-group-item><b>Customer Name</b>: {{ CustomerName }} </b-list-group-item>
                <b-list-group-item><b>Plan</b>: {{ PaymentPlanName }}</b-list-group-item>
                <b-list-group-item><b>Start Date</b>: {{ StartDate }}</b-list-group-item>
                <b-list-group-item><b>Amount</b>: ${{ Amount }}</b-list-group-item>
                <b-list-group-item><b>End Date</b>: {{ EndDate }}</b-list-group-item>
                <b-list-group-item><b>Status</b>: {{ Status }}</b-list-group-item>
                <b-list-group-item><b>Payment Plan Number</b>: {{ paymentPlanNumber }}</b-list-group-item>
                <b-list-group-item><b>Invoice</b>: {{ Invoice }}</b-list-group-item>
            </b-list-group>
            <b-card-body>
                <b-table :items="Installments" :fields="InstallmentsTableFields" striped>
                    <template #cell(amountDue)="row">
                        ${{Number.parseFloat(row.item.amountDue).toFixed(2)}}
                    </template>
                    <template #cell(paymentReceived)="row">
                        ${{Number.parseFloat(row.item.paymentReceived).toFixed(2)}}
                    </template>
                </b-table>
            </b-card-body>
            <b-button class="mt-3" block @click="$bvModal.hide('payment-plan-details')">Close</b-button>
        </b-modal>
    </div>

</template>

<script>


    import Repo from '../repo';

    export default {
        name: 'PaymentPlanDetailsModal',
        props: {
            paymentPlanNumber: Number | String,
        },
        data() {
            return {
                ANumber: '',
                CustomerName: '',
                PaymentPlanName: '',
                StartDate: '',
                Amount: '',
                EndDate: '',
                Status: '',
                Invoice: '',
                Installments: [],
                InstallmentsTableFields: [
                    {
                        key: 'installmentDueDate',
                        label: 'Installment Date'
                    },
                    {
                        key: 'amountDue',
                        label: 'Amount Due'
                    },
                    {
                        key: 'paymentReceived',
                        label: 'Amount Received'
                    }
                ],
                show: false
            }
        },
        mounted: async function() {

        },
        methods: {
            getPaymentPlanHistory(paymentPlanNumber) {
                return new Promise((resolve, reject) => {
                    this.$store.dispatch('shell/turnOnSpinner', true);
                    Repo.PaymentPlanService.GetPaymentPlanHistory({
                        customerNumber: this.$route.params.customerNumber,
                        paymentPlanNbr: paymentPlanNumber
                    }).then(res => {
                        if (res && res.paymentPlan) {
                            this.ANumber = res.paymentPlan.dpiCustNbr;
                            this.CustomerName = res.paymentPlan.custName;
                            this.PaymentPlanName = res.paymentPlan.paymentPlan;
                            this.StartDate = res.paymentPlan.enrollmentDate;
                            this.Amount = res.paymentPlan.amount;
                            this.EndDate = res.paymentPlan.endDate;
                            this.Status = res.paymentPlan.payStatusDesc;
                        }
                        if (res.invoice) {
                            this.Invoice = res.invoice.externalBillNbr + ' ( $' + res.invoice.amountDue + ' )';
                        }
                        this.$store.dispatch('shell/turnOffSpinner', false);
                        resolve(true);
                    });
                });
            },
            getPayPlanInstallments(paymentPlanNumber) {
                return new Promise((resolve, reject) => {
                    this.$store.dispatch('shell/turnOnSpinner', true);
                    Repo.PaymentPlanService.GetPayPlanInstallments({ payPlanNbr: paymentPlanNumber }).then(res => {
                        this.Installments = res.installments;

                        this.Installments.forEach(x => {

                            if (x.installmentDueDate == '9998-12-31T23:59:59.997') {
                                x.installmentDueDate = '';
                            } else {
                                let formatDate = new Date(x.installmentDueDate);
                                x.installmentDueDate = formatDate.getMonth() + 1 + "/" + formatDate.getDate() + "/" + formatDate.getFullYear();
                                console.log(x.installmentDueDate)
                            }
                            x.paymentReceived = x.amountDue - x.unpaidAmt;
                        });
                        this.$store.dispatch('shell/turnOffSpinner', false);
                        resolve(true);
                    });
                });
            },
            async showModal() {
                await this.getPaymentPlanHistory(this.paymentPlanNumber);
                await this.getPayPlanInstallments(this.paymentPlanNumber);
                this.show = true;
            }
        },
    };
</script>